export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.20-1003.56",
  commitId: "c942c993fe51f33e2031f3246c601329dd172254",
  commitTime: "2026-10-20T10:03:56.000Z",
});
